const phoneDigit = require("./constant/phoneDigit");
const countryName = require("./constant/countryName");
const currencySymbol = require("./constant/currencySymbol");
const currencyCode = require("./constant/currencyCode");
const countryCode = require("./constant/countryCode");
const blockedPaths = require("./constant/blockedPaths");
const tncConstant = require("./constant/tncConstant");
const storeConstant = require("./constant/storeConstant");
const showLoginWithPass = require("./constant/showLoginWithPass");
const mapCountry = require("./constant/mapCountry");
const tncUrlConstant = require("./constant/tncUrlConstant");
const googleSiteVerification = require("./constant/googleSiteVerification");
const defaultTncUrl = require("./constant/defaultTncUrl");
const defaultMenu = require("./constant/defaultMenu");
const helpDeskNo = require("./constant/helpDeskNo");
const defaultLoyaltyData = require("./constant/defaultLoyaltyData");

const getCountryName = (country) => {
  const india = ['in', 'india', 'ind'];
  const sriLanka = ['sl', 'lk', 'LK', 'srilanka'];
  const bangladesh = ['bg', 'bangla', 'bangladesh'];

  switch (true) {
    case india.includes(country):
      return countryName.IN;
    case sriLanka.includes(country):
      return countryName.LK;
    case bangladesh.includes(country):
      return countryName.BG;
    default:
      return -1;
  }
}

const getCountryShortName = (country) => {
  switch (country) {
    case countryName.IN:
      return 'IN';
    case countryName.LK:
      return 'LK';
    case countryName.BG:
      return 'BG';
    default:
      return -1;
  }
}

const getCountryConstants = (country) => {
  const countryShortName = getCountryShortName(getCountryName(country));
  return {
    COUNTRY_CODE: countryCode[countryShortName],
    PHONE_DIGIT: phoneDigit[countryShortName],
    CURRENCY_SYMBOL: currencySymbol[countryShortName],
    CURRENCY_CODE: currencyCode[countryShortName],
    BLOCKED_PATHS: blockedPaths[countryShortName],
    IS_WALLET_BLOCKED: countryShortName === 'LK',
    TNC: tncConstant[countryShortName],
    DEFAULT_STORE: storeConstant[countryShortName],
    SHOW_LOAGIN_WITH_PASSWORD : showLoginWithPass[countryShortName],
    GOOGLE_MAP_COUNTRY : mapCountry[countryShortName],
    TNC_URL : tncUrlConstant[countryShortName],
    DEFAULT_TNC_URL: defaultTncUrl[countryShortName],
    GOOGLE_SITE_VERIFICATION_ID: googleSiteVerification[countryShortName],
    DEFAULT_MENU: defaultMenu[countryShortName],
    HELP_DESK_NO: helpDeskNo[countryShortName],
    LOYALTY_INFO_DEFAULT_DATA: defaultLoyaltyData[countryShortName]

  }
}
module.exports = {getCountryName, getCountryConstants};